import {DateTime} from "luxon";


const CGT_START = 912668400;
const SECONDS = {
    YEAR: 31536000,
    DAY: 86400,
    HOUR: 3600,
    MINUTE: 60
};
const CGT_REGEX = /(?:(?:Year\s(?<year>\d+)\sDay\s(?<day>\d+))|(?:Y(?<year2>\d+)\s*D(?<day2>\d+)))[, ]?\s?(?:(?<hour>\d{1,2}):(?<minute>\d{2})(?::(?<second>\d{2}))?)?/;


declare module "luxon" {
    interface DateTime {
        toCGTObject(): CGTTime;
        toCGT(short?: boolean): string;

    }

    // Add static method to DateTime
    namespace DateTime {
        function fromCGT(
            year: number,
            day: number,
            hour?: number,
            minutes?: number,
            seconds?: number
        ): DateTime;
        function parseCGT(cgtString: string): DateTime;
        function isCGTString(cgtString: string): boolean;
    }
}
interface CGTTime {
    year: number;
    day: number;
    hour: number;
    minutes: number;
    seconds: number;
}




DateTime.prototype.toCGTObject = function () {
    let unix = Math.round(this.toSeconds());
    let diff = unix-CGT_START;

    let y = Math.floor(diff/SECONDS.YEAR)

    //diff -= (y*SECONDS.YEAR);
    let d = 1 + Math.floor(diff/SECONDS.DAY)%365;
    //diff -= (d*SECONDS.DAY);
    let h = Math.floor(diff/SECONDS.HOUR) % 24;
    //diff -= (h*SECONDS.HOUR);
    let m = Math.floor(diff/SECONDS.MINUTE) % 60;
    let s = diff % 60;
    //diff -= (m*SECONDS.MINUTE);

    return {
        year: y,
        day: d,
        hour: h,
        minutes: m,
        seconds: s
    }
}


DateTime.prototype.toCGT = function (short = false) {
    let obj = this.toCGTObject();
    let dd = (''+obj.day).padStart(3, '0');

    if(short) {
        return `Y${obj.year} D${dd}`;
    }
    let hh = (''+obj.hour).padStart(2, '0');
    let mm = (''+obj.minutes).padStart(2, '0');
    let ss = (''+obj.seconds).padStart(2, '0');
    return `Y${obj.year} D${dd} ${hh}:${mm}:${ss}`;
}



DateTime.fromCGT = function(year: number, day: number, hour=0, minutes= 0, seconds = 0) {
    return DateTime.fromSeconds(CGT_START + (year*SECONDS.YEAR) + ((Math.max(0, day-1))*SECONDS.DAY) + (hour*SECONDS.HOUR) + (minutes*SECONDS.MINUTE) + seconds);
}

DateTime.parseCGT = function(cgtString: string) {
    const match = cgtString.match(CGT_REGEX);
    if (!match || !match.groups) {
        throw new Error('Invalid CGT string ' + cgtString);
    }

    const { year, day, year2, day2, hour, minute, second } = match.groups;

    const y = parseInt(year ?? year2, 10);
    const d = parseInt(day ?? day2, 10);
    const h = hour !== undefined ? parseInt(hour, 10) : 0;
    const m = minute !== undefined ? parseInt(minute, 10) : 0;
    const s = second !== undefined ? parseInt(second, 10) : 0;


    return DateTime.fromCGT(y, d, h, m, s);
}

DateTime.isCGTString = function(cgtString: string) {
    return CGT_REGEX.test(cgtString);
}


export default DateTime;
